import * as React from 'react';
import doLog from '@/common/log';
import countrySite from '@/common/country-site';
import DetailIcon from '@/common/detail-icon';
import classNames from 'classnames';
import { viewMoreClick } from './handle';
const { useState, useEffect } = React;

import './index.less';
import { resetImage } from '@/common/reset-image';

export default function Index(props: any) {
  const [visible, setVisible] = useState(false);
  const [shown, setShown] = useState(false);
  const { i18n, shouldHideBuyerRight, buyerRightInfo = {}, productId } = props;

  useEffect(() => {
    if (shouldHideBuyerRight || !buyerRightInfo || !buyerRightInfo?.name) return;
    doLog('/sc.details.commonLogs', `productId=${productId}&action=BenefitsExp`, 'EXP');
  }, []);

  const { logo, name, viewMoreText, viewMoreUrl = '', levelId = -1, levelName } = buyerRightInfo;
  // 隐藏逻辑字段 || 无权益数据 || 无楼层字段
  if (shouldHideBuyerRight || !buyerRightInfo || !name) return null;

  // 检查域名是否为国家站
  const isNationalStation = countrySite();

  const viewMore = (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        if (isNationalStation && levelId === -1) {
          const xman = window.loadXman({});
          xman.show();
        } else {
          doLog('/sc.details.commonLogs', `productId=${productId}&action=NewBenefitsClk`);
          viewMoreClick(viewMoreUrl);
        }
      }}
    >
      {viewMoreText}
    </a>
  );

  return (
    <div className="buyer-benefits">
      <h4>
        <span>{i18n['detail_pc_membership_benefits']}</span>
        <DetailIcon
          onClick={() => setShown(!shown)}
          symbol={shown ? 'icon-up' : 'icon-down'}
          className={'detail-symbol buyer-arrow'}
        />
      </h4>
      <div
        className={classNames({
          'buyer-item': true,
          shown: shown,
        })}
      >
        {/* 选出第一个 */}
        {levelId > 0 && (
          <div className="level-icon">
            <span>{i18n['detail_pc_for_your_stage']}</span>
            <img className="golden-buyer-logo" src={resetImage(logo)} />
          </div>
        )}
        <span className="golden-buyer-first-benefit">{name}</span>
        {viewMore}
      </div>
    </div>
  );
}
